// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"Dashboard_dashboard__260VK","dashHead":"Dashboard_dashHead__NAvGE"};